
import GridItem from '../components/GridItem.vue'
import ConfirmationPopup from '../components/ConfirmationPopup.vue'

/* eslint-disable */
export default {
  components: {
    GridItem,
    ConfirmationPopup
  },
  head() {
    return {
      title: this.$t('favorites.metaTitle'),
      meta: [
        { hid: 'description', name: 'description', content: this.$t('favorites.metaDescription') },
        { hid: 'og:title', name: 'og:title', content: this.$t('favorites.metaTitle') },
        { hid: 'og:description', name: 'og:description', content: this.$t('favorites.metaDescription') },
        { hid: 'og:image', name: 'og:image', content: '~assets/img/showroom-fashionweek-bg.png' },
        { hid: 'og:url', name: 'og:url', content: process.env.NUXT_ENV_LOCAL_URL + '/demand/' }
      ],
      script: [{ type: 'application/ld+json', json: this.structuredData }]
    }
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      company: '',
      startDate: null,
      endDate: null,
      knowsCanal: [],
      message: '',
      success: false,
      canals: ['searchEngine', 'socialNetworks', 'contact', 'alrdKnown'],
      showPopup: false,
      structuredData: { // from https://schema.org/CheckoutPage
        "@context": "https://schema.org",
        "@type": "CheckoutPage",
        "about": this.$t('about_us.metaDescription'),
        "url": process.env.NUXT_ENV_LOCAL_URL + '/us/'
      }
    }
  },
  computed: {
    legalLink() {
      return (
        process.env.NUXT_ENV_API_URL +
        `/static/legal/ml-${this.$i18n.getLocaleCookie()}.pdf`
      )
    }
  },
  methods: {
    generateShareLink() {
      // Encode all salle Ids in a query string array
      const emailSubject = encodeURIComponent( this.$t('favorites.shareSelectedShowrooms') )
      let emailBody = `${this.$t('favorites.selectedShowrooms')} \n`
      for(let salle of this.$store.state.salles.favorites) {
        emailBody += `${process.env.NUXT_ENV_LOCAL_URL}/${salle.slug.toLowerCase()} \n`
      }
      return `mailto:?body=${encodeURIComponent(emailBody)}&subject=${emailSubject}`
    },
    returnToLastPage() {
      this.$router.go(-1)
    },
    validateForm() {
      if (!this.lastName) {
        const notification = {
          type: 'error',
          message: this.$t('send_request.nameNeeded')
        }
        this.$store.dispatch('notification/add', notification)
        return
      }
      if (!this.email) {
        const notification = {
          type: 'error',
          message: this.$t('send_request.emailNeeded')
        }
        this.$store.dispatch('notification/add', notification)
        return
      }
      // Si la validation passe, on affiche la modale
      this.showPopup = true
    },
    handlePopupClose() {
      this.showPopup = false
      this.submit()
    },
    submit() {
      const demand = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
        company: this.company,
        startDate: this.startDate,
        endDate: this.endDate,
        message: this.message,
        salles: this.$store.state.salles.favorites,
        knowsCanal: this.knowsCanal
      }
      this.$axios
        .post(process.env.NUXT_ENV_API_URL + '/demands', demand)
        .then(() => {
          this.$router.push(this.localePath('lieux'))
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            let message = "Une erreur s'est produite"
            if (err.response.data.message === 'Please send a last name') {
              message = this.$t('send_request.nameNeeded')
            }
            if (err.response.data.message === 'Please send an email') {
              message = this.$t('send_request.emailNeeded')
            }
            const notification = {
              type: 'error',
              message
            }
            this.$store.dispatch('notification/add', notification)
          }
          console.error(err.response)
        })
    },
    removeFromFavorites(salleId) {
      this.$store.dispatch('salles/removeFavoriteSalle', salleId)
    }
  }
}
